module.exports = __webpack_public_path__ + "static/media/webSignUp.0fdeb050.png";